document.addEventListener("DOMContentLoaded", () => {
  function toggleHandWrittenNoteInput(inputValue) {
    if (inputValue.includes("Yes - add a note")) {
      //show note input
      handWrittenNoteInput.classList.remove("hidden");
    } else {
      //hide note input
      if (handWrittenNoteInput.value !== "") {
        handWrittenNoteInput.classList.add("hidden");
        const textArea = handWrittenNoteInput.querySelector("textarea");
        textArea.value = "";
      }
    }
  }

  const simpleBundleOptionsWrapper = document.querySelector(
    "div [data-simple-bundles-options]"
  );
  const handWrittenNoteInput = document.querySelector(
    ".gift-box-prebuilt-bundle-note"
  );

  if (simpleBundleOptionsWrapper && handWrittenNoteInput) {
    // Attach listener to the wrapper to work around dynamic loading
    simpleBundleOptionsWrapper.addEventListener("change", (e) => {
      if (e.target.id === "gift-box-wrapping-and-hand-written-note") {
        toggleHandWrittenNoteInput(e.target.value);
      }
    });

    // on page init, set note input visibility
    const handWrittenNoteSelect = simpleBundleOptionsWrapper.querySelector(
      "#gift-box-wrapping-and-hand-written-note"
    );
    if (handWrittenNoteSelect) {
      toggleHandWrittenNoteInput(handWrittenNoteSelect.value);
    }

    setTimeout(() => {
      //hide dropdowns that only have one option
      const selectWrapper = simpleBundleOptionsWrapper.children[0];
      Array.from(selectWrapper.children).forEach((element) => {
        if (element.nodeName === "SELECT" && element.options.length <= 2) {
          element.style = "display:none;";

          const targetLabel = selectWrapper.querySelector(
            `label[for='${element.id}']`
          );
          targetLabel.style = "display:none;";
        }
      });
    }, 1000);
  }
});
